module.exports = __webpack_public_path__ + "img/9建组20220420_101035.947985a4.gif";